import { DashboardCard } from "@/shared/ui/DashboardCard";
import { useTranslation } from "@/shared/providers/LanguageProvider";
import { recentOrders } from "../data";

const statusStyles = {
  completed: "bg-teal-soft text-teal",
  pending: "bg-yellow-soft text-yellow",
  shipped: "bg-primary-soft text-primary",
};

const statusKeys = {
  completed: "completed",
  pending: "pending",
  shipped: "shipped",
} as const;

export function RecentOrders() {
  const { t } = useTranslation();

  return (
    <DashboardCard title={t.ecommerce.recentOrders} className="col-span-full md:col-span-2">
      <div className="overflow-x-auto">
        <table className="w-full text-left text-sm">
          <thead>
            <tr className="border-b border-border text-xs text-muted">
              <th className="pb-3 font-medium">{t.common.order}</th>
              <th className="pb-3 font-medium">{t.common.customer}</th>
              <th className="pb-3 font-medium">{t.common.product}</th>
              <th className="pb-3 font-medium">{t.common.amount}</th>
              <th className="pb-3 font-medium">{t.common.status}</th>
            </tr>
          </thead>
          <tbody>
            {recentOrders.map((order) => (
              <tr key={order.id} className="border-b border-border">
                <td className="py-3 font-medium text-primary">{order.id}</td>
                <td className="py-3 text-foreground">{order.customer}</td>
                <td className="py-3 text-muted-foreground">{order.product}</td>
                <td className="py-3 font-medium text-foreground">{order.amount}</td>
                <td className="py-3">
                  <span className={`rounded-full px-2.5 py-1 text-xs font-medium ${statusStyles[order.status]}`}>
                    {t.common[statusKeys[order.status]]}
                  </span>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </DashboardCard>
  );
}
